




















/* General */
import Vue from 'vue'
import { debounce } from 'lodash'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'IfpFilterTitleRefSearch',

  props: {
    searchTerm: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      internalSearchTerm: '',
      emphasizeFilter: false,
      debounceUpdateSearchTerm: null,
    }
  },

  computed: {
    hasInternalSearchTerm(): boolean {
      return (
        this.internalSearchTerm !== null &&
        this.internalSearchTerm.trim().length > 0
      )
    },
  },

  watch: {
    searchTerm: {
      immediate: true,
      handler(val) {
        this.internalSearchTerm = val
      },
    },
  },
  created() {
    this.debounceUpdateSearchTerm = debounce(this.updateSearchTerm, 500)
  },
  mounted() {
    if (this.hasInternalSearchTerm) {
      // @ts-ignore
      this.$refs.inputRef.focus()
    }
  },
  methods: {
    updateSearchTerm(val: string) {
      this.$emit('search-term-updated', val)
    },
    handleInput(val: string) {
      this.internalSearchTerm = val
      this.debounceUpdateSearchTerm(val)
    },
  },
})
